import { IconShield, IconArrowUpRight } from '@tabler/icons-react';
import LinkNoPrefetch from '@/components/link-noprefetch';
import { DotBlockEditor } from '@/components/shared/decodeTextBlock';
import customRenderers from '@/components/block-editor';
import safeJsonParse from '@/app/utils/safeJSONParse';

// Renders a plain string, converting *text* into bold italic fuschia spans.
function renderWithMarkdownBold(text) {
    if (!text) return null;
    const parts = text.split(/(\*[^*]+\*)/g);
    return parts.map((part, i) => {
        if (part.startsWith('*') && part.endsWith('*')) {
            return (
                <em key={i} className="font-bold italic text-fuschia-700">
                    {part.slice(1, -1)}
                </em>
            );
        }
        return part;
    });
}

function FeatureCard({ index, body, body_raw }) {
    const parsedBody = body ?? safeJsonParse(body_raw);
    return (
        <div className="flex flex-col rounded-2xl bg-blue-650 p-8">
            <span className="font-mono text-xs text-blue-500">
                {String(index).padStart(2, '0')}
            </span>
            {parsedBody && (
                <div className="prose max-w-none prose-p:text-sm prose-p:font-normal prose-p:leading-snug prose-p:text-white prose-p:last:mb-0 prose-p:empty:hidden prose-a:text-fuschia-700">
                    <DotBlockEditor customRenderers={customRenderers} blocks={parsedBody} />
                </div>
            )}
        </div>
    );
}

function FeatureSplit({ splitHeading, splitBody, callToAction, sections }) {
    const sectionList = Array.isArray(sections) ? sections : [];
    const [button] = Array.isArray(callToAction) ? callToAction : [];

    return (
        <section className="background-dark py-20 lg:py-28" data-component="feature-split">
            <div className="container grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
                <div className="flex flex-col justify-center gap-6">
                    {splitHeading && (
                        <h2 className="text-4xl font-bold leading-tight text-white lg:text-5xl">
                            {renderWithMarkdownBold(splitHeading)}
                        </h2>
                    )}
                    {splitBody && (
                        <p className="max-w-md whitespace-pre-line text-base text-blue-400">
                            {splitBody}
                        </p>
                    )}
                    {button && button.urlName && button.url && (
                        <LinkNoPrefetch
                            href={button.url}
                            className="mt-2 inline-flex items-center gap-2 text-base font-semibold text-fuschia-600 underline decoration-fuschia-600 underline-offset-4 hover:text-fuschia-500 hover:decoration-fuschia-500">
                            <IconShield size={18} aria-hidden />
                            <span>{button.urlName}</span>
                            <IconArrowUpRight size={18} aria-hidden />
                        </LinkNoPrefetch>
                    )}
                </div>

                {sectionList.length > 0 && (
                    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                        {sectionList.map((item, i) => (
                            <FeatureCard
                                key={item?.identifier ?? i}
                                index={i + 1}
                                body={item?.body}
                                body_raw={item?.body_raw}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default FeatureSplit;
